import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Icon from '@vtblife/uikit-icons';
import classNames from 'classnames';
import s from './link.module.css';
import { useRel, useVariant } from './utils';
const RouterHashLink = (props) => React.createElement(HashLink, Object.assign({}, props, { smooth: true }));
const RRLink = ({ href = '', target = 'self', children, text: body = true, variant = 'primary', external = false, rel: externalRel, dataTest, onClick, gtm, visited, to: toProp, }) => {
    const to = toProp || href;
    const isHashLink = useMemo(() => (typeof to === 'string' && to.indexOf('#') > -1) || (typeof to === 'object' && to.hash), [to]);
    const LinkComponent = (isHashLink ? RouterHashLink : RouterLink);
    const variants = useVariant(variant);
    const rel = useRel(externalRel, target);
    return (React.createElement(LinkComponent, { target: '_' + target, className: classNames(s.reset, body && s.body, visited && s.visited, ...variants.map(v => s[v])), to: to, rel: rel, "data-test": dataTest, "data-gtm": gtm, onClick: onClick },
        children,
        body && external && (React.createElement("span", { className: s.external },
            React.createElement(Icon, { name: "square-arrow", size: "s" })))));
};
export default RRLink;
//# sourceMappingURL=RRLink.js.map